export default {
  methods: {
    show_dental_certificate(id) {
      let newWindow = window.open(this.getApiAuthUrl('dental/guarantees/' + id + '/certificate') + "&show_type=download");
    },
    show_pdf(id) {
      let newWindow = window.open(this.getApiAuthUrl('garantie/generate-pdf/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_pdf_mensualisee(id) {
      let newWindow = window.open(this.getApiAuthUrl('garantie/generate-assur-garanties-mecaniques-pdf-quote/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_assurance_pdf(id) {
      let url = this.getApiAuthUrl('insurances/generate-pdf/' + id) + "&show_type=stream";
      let newWindow = window.open(url);
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_quittance(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-quittance/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_quittance_emise(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-quittance-emise/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_parc(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-parc/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_parc_complete(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-parc-complete/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },

    show_carte_assistance(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-assistance-new-card/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },

    show_cp(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-pdf/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },

    show_accompagnement(id) {
      let newWindow = window.open(this.getApiAuthUrl('mutuaide/generate-accompagnement/' + id) + "&show_type=stream");
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    show_attestation_pdf(id) {
      let url = this.getApiAuthUrl('insurances/generate-attestation-pdf/' + id) + "&show_type=stream";
      let newWindow = window.open(url);
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    },
    preview_pdf(url, params) {
      let newWindow = window.open(this.getApiAuthUrl(url) + params);
      //console.log(newWindow); //todo: need testing for case of blocking new windows
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pdfPreviewMixin.js